import { FeatureCollection, PipeType } from '@api-model/models';
import { Bounds, BoundsCorners, Coords } from '@models/boundsCorners';
import { styleConstants } from '@styles/constants';

export interface Props {
  center?: Coords;
  zoom?: number;
}

export interface PopupDataState {
  id: string | null;
  lat: number;
  lng: number;
  type: PipeType | null;
}

export const defaultMapParams: Required<Props> = {
  center: {
    lat: 53.3719132,
    lng: -1.4681042,
  },
  zoom: 7,
};

export const ZOOM_FOR_PIPES = 17;
export const ZOOM_FOR_CLUSTERS = 15;

export const defaultCloseupZoom = 15;

export const parseBoundsToCorners = (bounds: Bounds): BoundsCorners => {
  if (!bounds) return null;

  return { topLeft: bounds.nw, bottomRight: bounds.se };
};

export const parseLatLngBoundsToBounds = (corners: google.maps.LatLngBounds): Bounds => {
  const { lat: latNE, lng: lngNE } = corners.getNorthEast();
  const { lat: latSW, lng: lngSW } = corners.getSouthWest();

  return {
    sw: {
      lat: latSW(),
      lng: lngSW(),
    },
    se: {
      lat: latSW(),
      lng: lngNE(),
    },
    ne: {
      lat: latNE(),
      lng: lngNE(),
    },
    nw: {
      lat: latNE(),
      lng: lngSW(),
    },
  };
};

export const createMapOptions = (): google.maps.MapOptions => {
  return {
    mapId: 'SG_map',
    streetViewControl: true,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    fullscreenControl: true,
    fullscreenControlOptions: {
      position: google.maps.ControlPosition.BOTTOM_RIGHT,
    },
    mapTypeControl: true,
    mapTypeControlOptions: {
      style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
      position: google.maps.ControlPosition.TOP_LEFT,
      mapTypeIds: [
        google.maps.MapTypeId.ROADMAP,
        google.maps.MapTypeId.SATELLITE,
        google.maps.MapTypeId.HYBRID,
        google.maps.MapTypeId.TERRAIN,
      ],
    },
  };
};

export const parseQueryString = (queryString: string) => {
  const queryObject = new URLSearchParams(queryString);

  const lat = parseFloat(queryObject.get('lat') ?? '');
  const lng = parseFloat(queryObject.get('lng') ?? '');
  const zoom = parseInt(queryObject.get('zoom') ?? '');

  return { lat, lng, zoom };
};

// pipes
export const drawPipes = (
  dataLayer: google.maps.Data,
  pipesCollection: FeatureCollection,
  type: PipeType,
  setPopupData: React.Dispatch<React.SetStateAction<PopupDataState>>
) => {
  dataLayer.addGeoJson(pipesCollection);
  dataLayer.setStyle({
    strokeWeight: 2,
    strokeColor: type === PipeType.WasteFoulPipe ? styleConstants.colors.foulPipe : styleConstants.colors.surfacePipe,
  });
  dataLayer.addListener('click', (e: any) => {
    setPopupData({
      id: e.feature.j,
      lat: e.latLng.lat(),
      lng: e.latLng.lng(),
      type,
    });
  });
};
export const removePipes = (dataLayer: google.maps.Data) => {
  dataLayer.forEach((feature) => {
    dataLayer.remove(feature);
  });
};
